import Icon from 'atomic/icon';
import React from 'react';
import Circle from 'atomic/circle/circle';
import classNames from 'classnames';
import { usePagination } from 'components/paginations/use-pagination';
import { PaginationProps } from 'components/paginations/pagination.interface';
import { useSeo } from 'hooks/use-seo';

import './pagination.scss';

const Pagination: React.FC<PaginationProps> = ({
    count,
    siblingCount = 1,
    page,
    limit,
    getUrl
}) => {
    const seo = useSeo();

    const paginationRange = usePagination(
        count,
        limit,
        siblingCount,
        page
    );

    if (page === 0 || paginationRange.length < 2) {
        return null;
    }

    const lastPage = paginationRange[paginationRange.length - 1];

    return (
        <div className="pagination">
            { page !== 1 && (
                <a
                    href={getUrl(page - 1)}
                    rel={seo.rel}
                    className={classNames(
                        {
                            ['pagination__item']: true,
                            ['pagination__item--prev']: true,
                            ['pagination__item--w-100']: lastPage === page
                        }
                    )}
                    aria-label="Wstecz"
                >
                    <Circle
                        tag="div"
                        background="transparent"
                        border="secondary"
                        color="secondary"
                    >
                        <Icon name="arrow-left" color="secondary" size={16} />
                    </Circle>
                    <span>Wstecz</span>
                </a>
            )}
            <div
                className={classNames(
                    {
                        ['pagination-range']: true,
                        ['pagination-range-center']: paginationRange.length !== 7
                    }
                )}
            >
                { paginationRange.map((pageNumber: number | string, idx) => {
                    if (pageNumber === '...') {
                        return (
                            <Circle
                                className="pagination__item"
                                tag="div"
                                background="transparent"
                                border="transparent"
                                color="dark"
                                key={idx}
                            >
                                <span>&#8230;</span>
                            </Circle>
                        );
                    }

                    return (
                        <Circle
                            className="pagination__item"
                            tag="a"
                            rel={seo.rel}
                            href={getUrl(Number(pageNumber))}
                            background={pageNumber === page ? 'secondary' : 'transparent'}
                            border={pageNumber === page ? 'secondary' : 'transparent'}
                            color={pageNumber === page ? 'white' : 'dark'}
                            key={idx}
                        >
                            <span>{pageNumber}</span>
                        </Circle>
                    );
                })}
            </div>
            { lastPage !== page && (
                <a
                    href={getUrl(page + 1)}
                    rel={seo.rel}
                    className={classNames(
                        {
                            ['pagination__item']: true,
                            ['pagination__item--next']: true,
                            ['pagination__item--w-100']: page === 1
                        }
                    )}
                    aria-label="Dalej"
                >
                    <span>Dalej</span>
                    <Circle
                        tag="div"
                        background="transparent"
                        border="secondary"
                        color="secondary"
                    >
                        <Icon name="arrow-right" color="secondary" size={16} />
                    </Circle>
                </a>
            )}
        </div>
    );
};

export default Pagination;
